<template>
  <v-menu
    nudge-bottom="1"
    bottom
    origin="center center"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" flat color="grey">
        <v-icon>{{ icon }}</v-icon>
        {{ title }}
        <v-icon>arrow_drop_down</v-icon>
      </v-btn>
    </template>

    <slot></slot>
  </v-menu>
</template>

<script>
export default {
  props: ["title", "icon"]
};
</script>
